meedy.controller('meedy.popupFillDataController', ['$rootScope', '$scope', '$mdDialog',
    function ($rootScope, $scope, $mdDialog, title, message) {

        $scope.save = function () {
            $mdDialog.hide();
        };
    }]);
